import { ERouteName } from './config/index';
import { url } from '@tencent/ppd-base-libs';
import Vue from 'vue';
import Router from 'vue-router';
import HomeNewest from './views/home-newest/index.vue';
import Home from './views/home.vue';
import { ExposureObserver } from '@tencent/fit-bi-sdk';
import { clearShare } from './views/WeCoupons/utils/view-helper';
import { isHKLBSpecialRedirect, redirectToHKLBChannelPage } from './business/special-redirect';

Vue.use(Router);

// 为了兼容春节期间的跳转逻辑，从 path:/进入到spring-home（name = spring-home）,根据时间决定跳spring-act还是home
const springHomeRoute = [
  {
    path: '/',
    name: 'spring-home',
    beforeEnter: async (to, from, next) => {
      /**
       * 存在?page=xxxx的页面有以下：
       * couponlist
       * weCoupons
       * displaycouponlist
       * displaycoupondetail
       */
      const page = url.getUrlParam('page');
      if (page && !from.name) {
        // 这里的问题：优惠专区改版后，?page=couponlist进入了卡券tab，然后点击「优惠」(home页面)，发现无法跳转
        // 解决方案：判断from.name是否为空，如果为空才执行这里的逻辑
        return next({ path: `/${page}`, replace: true });
      }
      return next({ name: 'home', replace: true });
    },
  },
  {
    path: '/home',
    name: 'home',
    cname: '优惠专区聚合首页',
    component: Home,
    children: [
      {
        path: 'couponList/:classId', // 券列表页面
        name: ERouteName.homeWeCouponsList,
        cname: 'wecoupons券列表',
        component: () => import(/* webpackChunkName: "wecoupons-coupon-list" */ './views/WeCoupons/coupon-list.vue'),
      },
    ],
  },
  {
    path: '/homeNewest',
    name: 'homeNewest',
    cname: '新版首页',
    component: HomeNewest,
    beforeEnter: async (to, from, next) => next({ name: 'home', replace: true }),
  },
];

const routes = [
  ...springHomeRoute,
  {
    path: '/stamplist',
    name: 'stamplist',
    component: () => import(/* webpackChunkName: "stamp-list" */ './views/StampList.vue'),
  },
  {
    path: '/unusestamplist',
    name: 'unusestamplist',
    component: () => import(/* webpackChunkName: "unuse-stamp-list" */ './views/UnuseStampList.vue'),
  },
  {
    path: '/discountrecord',
    name: 'discountrecord',
    component: () => import(/* webpackChunkName: "discount-record" */ './views/DiscountRecord.vue'),
  },
  {
    path: '/displaycouponlist',
    name: 'displaycouponlist',
    component: () => import(/* webpackChunkName: "display-coupon-list" */ './views/DisplayCouponList.vue'),
  },
  {
    path: '/displaycoupondetail',
    name: 'displaycoupondetail',
    cname: '展示券详情页',
    component: () => import(/* webpackChunkName: "display-coupon-detail" */ './views/DisplayCouponDetail.vue'),
  },
  {
    path: '/couponlist',
    name: 'couponlist',
    component: () => import(/* webpackChunkName: "coupon-list" */ './views/CouponList/index.vue'),
  },
  {
    path: '/couponDetail',
    name: 'couponDetail',
    cname: '优惠券详情页',
    component: () => import(/* webpackChunkName: "coupon-detail" */ './views/coupon-detail/index.vue'),
  },
  {
    path: '/voucherlist',
    name: 'voucherlist',
    component: () => import(/* webpackChunkName: "voucher-list" */ './views/Voucher/index.vue'),
  },
  {
    path: '/coupon-exchange',
    name: 'couponExchange',
    component: () => import(/* webpackChunkName: "coupon-exchange" */ './views/coupon-exchange/index.vue'),
  },
  {
    path: '/voucherDetail',
    name: 'voucherDetail',
    component: () => import(/* webpackChunkName: "voucher-list" */ './views/Voucher/detail.vue'),
  },
  {
    // 抢券有So首页
    path: '/weCoupons',
    cname: '抢券有So首页',
    name: 'weCoupons',
    component: () => import(/* webpackChunkName: "wecoupons-index" */ './views/WeCoupons/index.vue'),
    children: [
      {
        path: 'couponList/:classId', // 券列表页面
        name: ERouteName.weCouponsList,
        cname: '抢券有So首页-券列表',
        component: () => import(/* webpackChunkName: "wecoupons-coupon-list" */ './views/WeCoupons/coupon-list.vue'),
      },
      {
        path: 'merchantList/:classId', // 商户列表
        name: ERouteName.weCouponsSpList,
        cname: '抢券有So首页-商户列表',
        component: () => import(/* webpackChunkName: "wecoupons-merchant-list" */ './views/WeCoupons/merchant-list.vue'),
      },
    ],
  },
  {
    path: '/couponsSearch', // 券搜索页
    name: ERouteName.couponsSearch,
    cname: '抢券有So首页-券搜索页',
    component: () => import(/* webpackChunkName: "wecoupons-coupon-search" */ './views/WeCoupons/coupon-search.vue'),
  },
  {
    // 抢券有So商户页面
    path: '/weCouponMerchants',
    name: 'weCouponMerchants',
    cname: '抢券有So首页-商户页面',
    component: () => import(/* webpackChunkName: "wecoupons-merchants" */ './views/WeCoupons/merchant-list.vue'),
  },
  {
    path: '*',
    beforeEnter: async (to, from, next) => next({ path: '/', replace: true }),
    component: HomeNewest,
  },
];


// export default router;
export function routerInit() {
  const router = new Router({
    routes,
  });

  router.beforeEach((to, from, next) => {
    if (isHKLBSpecialRedirect()) {
      // 处理扫码小巴活动特殊跳转
      return redirectToHKLBChannelPage();
    }

    if (to.name === 'home' || to.path === '/' || to.name === 'homeNewest') {
      // 页面停留上报检测初始化，设置较小参数threshold
      ExposureObserver.getInstance({ threshold: 0.1 }, true);
    } else if (to.name === 'weCoupons' || to.name === ERouteName.weCouponsList || to.name === ERouteName.weCouponsSpList) {
      ExposureObserver.getInstance({ threshold: 0.1 }, true);
    } else {
      ExposureObserver.getInstance({ threshold: 0.3 }, true);
    }

    // 微信分享隐藏
    // eslint-disable-next-line max-len
    if (![ERouteName.weCouponsList, ERouteName.weCouponsSpList, ERouteName.couponsSearch, ERouteName.homeWeCouponsList].includes(to.name as ERouteName)) {
      // 只有数组里的页面允许分享，其他的要隐藏
      clearShare();
    }

    next();
  });
  return router;
}
